// extracted by mini-css-extract-plugin
var _1 = "InputField_badge__5b55e";
var _2 = "InputField_disabled__d0251";
var _3 = "InputField_root__5a3cd";
var _4 = "InputField_selected__6b763";
export { _1 as "badge", _2 as "disabled", _3 as "root", _4 as "selected" }
